import contentService from '@/services/contentService';
import {collectPathsFromContent} from '@/utils/contentImageUtils';

const SW_MESSAGE_TYPE = 'PRECACHE_MEDIA';

const warmImageCache = (content) => {
    if (!content) return;

    const controller = navigator.serviceWorker?.controller;

    if (!controller) {
        console.info('[swCacheService] No active SW controller — skipping cache warm');
        return;
    }

    const paths = collectPathsFromContent(content);

    if (paths.length === 0) return;

    const urls = [...new Set(paths.map((item) => contentService.getContentPath(item.path)).filter(Boolean))];

    if (urls.length === 0) return;

    controller.postMessage({type: SW_MESSAGE_TYPE, urls});
};

const swCacheService = {warmImageCache};

export default swCacheService;
